import { render, staticRenderFns } from "./edit-custom-consent-agreement.vue?vue&type=template&id=bf8095ee&scoped=true&"
import script from "./edit-custom-consent-agreement.vue?vue&type=script&lang=js&"
export * from "./edit-custom-consent-agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8095ee",
  null
  
)

export default component.exports